import * as yup from 'yup'

const schema = yup
  .object({
    first_name: yup
      .string()
      .matches(/^[a-zA-Z ]+$/, 'Make sure you fill in your details in English only.')
      .required('Please complete this required field.'),
    last_name: yup
      .string()
      .matches(/^[a-zA-Z ]+$/, 'Make sure you fill in your details in English only.')
      .required('Please complete this required field.'),
    email: yup
      .string()
      .email('Email must be formatted correctly.')
      .required('Please complete this required field.'),
    phone: yup
      .string()
      .matches(/^[0-9()*#+\-]+$/, 'The Phone Number must be a number')
      // .min(14, 'Please complete this required field.')
      .required('Please complete this required field.'),
    job_title: yup.string().required('Please complete this required field.'),
    company_name: yup.string().required('Please complete this required field.'),
    number_of_employees: yup
      .string()
      .matches(/^\d+$/, 'The Number must be a number')
      .required('Please complete this required field.'),
    industry: yup.string().required('Please select an option from the dropdown menu.'),
    know_how: yup.string().required('Please select an option from the dropdown menu.'),
    allow: yup.string().required('Please select an option from the checkbox.'),
  })
  .required()

export default schema
